import moment from 'moment';
import _ from 'lodash';
import {
  BetTypeGroup, Market, Mode, E_SPORT_ID
} from '../common/Foundation';
import Constants from '../common/Constants';
import CommonUtil from '../common/CommonUtil';

export default class SelectLeagueAction {

  static isOutright(mode) {
    return mode === Mode.OUTRIGHT || mode === Mode.OUTRIGHT_MARKET;
  }

  static isParlay(mode) {
    return mode === Mode.PARLAY || mode === Mode.PARLAY_MARKET || mode === Mode.VS_PARLAY;
  }

  static isTeaser(mode) {
    return mode === Mode.TEASER || mode === Mode.TEASER_MARKET;
  }

  static betTypeGroup(mode, betTypeGroup) {
    if (this.isParlay(mode)) {
      return BetTypeGroup.HDP_OU;
    } else if(this.isTeaser(mode)) {
      return BetTypeGroup.TEASERS;
    }
    return betTypeGroup;
  }

  static buildLeaguesParamsAPI(options) {
    const {
      betTypeGroup, sportId, market, mode, period,
      filterOptions, timeFilter, country = '', favourite, favouriteLeagueId, searchLeagueId, searchSportId,
      isTopLeague, topLeagueLeagueId
    } = options;

    let date = _.get(filterOptions, 'selectedDate')

    if(date === '' && market === Market.Today){
      date = moment().format('YYYY-MM-DD')
    }

    const parameters = {
      'btg': this.betTypeGroup(mode, betTypeGroup),
      'd': date,
      'tm': market === Market.Today ? timeFilter : 0,
      'c': country,
      'l': true,
      'pn': CommonUtil.getPeriodNumParam(period),
    };
    const allMarket = (favourite && favouriteLeagueId) || ( isTopLeague && topLeagueLeagueId) || (mode === Mode.SEARCH && searchLeagueId);
    if (this.isParlay(mode)) {
      parameters['sp'] = sportId;
      parameters['mk'] = Market.Today;
      parameters['pa'] = 1;
    } else {
      parameters['sp'] = mode === Mode.SEARCH ? searchSportId : sportId;
      parameters['mk'] = allMarket ? Market.ALL : market;
      parameters['pa'] = 0;
    }

    return parameters;
  }

  static buildOutrightLeaguesParamsAPI(options) {
    const { sportId, outright, market } = options;

    return {
      sportId,
      ort: outright.outrightType,
      mk: market
    }
  }

  static buildEsportLeaguesParamsAPI(options) {
    const {
      sportId, market, betTypeGroup,
      mode, timeFilter, parlay,
      eSports, country = '', outright, period, favourite, favouriteLeagueId,
      isTopLeague, topLeagueLeagueId
    } = options;
    
    const isParlay = this.isParlay(mode);
    const isOutright = this.isOutright(mode);
    let outrightType = !isOutright ? -1 : outright.outrightType;
    let date = '';
    if (isParlay) {
      date = (market === Market.Live || market === Market.Today) ? moment().utcOffset("GMT-04:00").format("YYYY-MM-DD") : parlay.date;
    }
    const allMarket = (favourite && favouriteLeagueId) || ( isTopLeague && topLeagueLeagueId);
    return {
      sp: sportId,
      mk: allMarket || mode === Mode.OUTRIGHT ? Market.ALL : market,
      btg: isParlay ? BetTypeGroup.HDP_OU : betTypeGroup,
      d: date,
      tm: market === Market.Today ? timeFilter : 0,
      c: country,
      l: true,
      pa: isParlay ? 1 : 0,
      pn: period == 0 ? -1 : period,
      ec: _.get(eSports, 'eSportCode', ''),
      ort: mode === Mode.OUTRIGHT ? -2 : outrightType
    }
  }

  static convertToSelectLeagues(data, mode) {
    const leagues = [];
    if (data) {
      const isTeaser = this.isTeaser(mode);
      _.forEach(data, (value) => {
        let leagueId;
        let leagueName;
        let priority = 0;
        
        if (mode === Mode.OUTRIGHT) {
          leagueId = Object.keys(value)[0];
          leagueName = Object.values(value)[0];
        } else {
          leagueId = value[0];
          leagueName = isTeaser ? value[1] : value[2];
          priority = isTeaser ? priority : value[1];
        }

        leagues.push({
          leagueId: leagueId,
          leagueName: leagueName,
          priority: priority
        });
      })
    }

    return _.sortBy(leagues, ['priority', 'leagueName']);
  }

  static convertToESportSelectLeagues(data) {
    const result = [];
    if (data) {
      _.forEach(data, (leagues, gameName) => {
        _.forEach(leagues, (league, gameName) => {
          const leagueId = league[0];
          const leagueName = league[2];
          const priority = 0;
          result.push({
            leagueId: leagueId,
            leagueName: leagueName,
            priority: priority
          });
        })
      });
    }

    return _.sortBy(result, ['priority', 'leagueName']);
  }

  static updateSelectedLeagueOptions(options, filterLeagues = [], selectedLeaguesHistory = [], isSelectedAllLeagues = false) {
    const updatedOptions = {};
    const { sportId, mode, eSports, outright } = options;

    if (sportId === E_SPORT_ID) {
      updatedOptions.eSports = {
        ...eSports,
        eSportLeagueIds: isSelectedAllLeagues ? [] : (filterLeagues && filterLeagues.length > 0 ? filterLeagues : selectedLeaguesHistory)
      };
    } else if (this.isOutright(mode)) {
      updatedOptions.outright = {
        ...outright,
        leagueIds: isSelectedAllLeagues ? [] : (filterLeagues && filterLeagues.length > 0 ? filterLeagues : selectedLeaguesHistory)
      };
    } else {
      updatedOptions['leagueIds'] = isSelectedAllLeagues ? [] : (filterLeagues && filterLeagues.length > 0 ? filterLeagues : selectedLeaguesHistory);
    }
    
    return updatedOptions;
  }

  static updateLeaguesHistory(listLeagues, sportId, isAllSelectedLeague, selectedLeague, selectedMarketTab, selectedMarketId, selectedEsportGame) {
    let leaguesHistory = JSON.parse(JSON.stringify(listLeagues));
    const findSportLeague = listLeagues.find(league => {
      return sportId === E_SPORT_ID ? league.selectedEsportGame === selectedEsportGame : league.sportId === sportId;
    })
    if(findSportLeague) {
      leaguesHistory = listLeagues.map(item => {
        const league = JSON.parse(JSON.stringify(item));
        if(league.sportId === sportId || league.selectedEsportGame === selectedEsportGame) {
          const index = findSportLeague.selectedLeagues.findIndex(league => league.selectedMarketTab === selectedMarketTab && league.selectedMarketId === selectedMarketId);
          if(index > -1) {
            const historySelectedTab = league.selectedLeagues[index];
            historySelectedTab.leaguesHistory = isAllSelectedLeague ? [] : selectedLeague;
            historySelectedTab.isSelectedAllLeagues = isAllSelectedLeague;
          } else {
            league.selectedLeagues.push({
              selectedMarketTab: selectedMarketTab,
              selectedMarketId: selectedMarketId,
              leaguesHistory : selectedLeague,
              isSelectedAllLeagues: isAllSelectedLeague
            })
          }
        }
        return league;
      });
    } else {
      const historyLeagues = {
        selectedMarketTab: selectedMarketTab,
        selectedMarketId: selectedMarketId,
        leaguesHistory : selectedLeague,
        isSelectedAllLeagues: isAllSelectedLeague
      };
      if(sportId === E_SPORT_ID) {
        leaguesHistory.push({selectedEsportGame: selectedEsportGame, selectedLeagues: [historyLeagues]});
      } else {
        leaguesHistory.push({sportId: sportId, selectedLeagues: [historyLeagues]});
      }
    }
    return leaguesHistory;
  }

  static checkSelectedAllLeagues(allLeagueIds, selectedLeagues, isSelectedAllLeagues) {
    return (isSelectedAllLeagues && _.isEmpty(selectedLeagues)) || _.isEmpty(allLeagueIds) || (!_.isEmpty(allLeagueIds) && _.isEmpty(_.difference(allLeagueIds, selectedLeagues)));
  }
}


// WEBPACK FOOTER //
// ./src/app/actions/SelectLeagueAction.js